import { postalCodePatterns, postalCodePlaceholders } from "types";

class PostalCodeService {
  public getPattern(countryName: string): RegExp | null {
    return postalCodePatterns[countryName.toLowerCase()] || null;
  }

  public validate(postalCode: string, countryName: string): boolean {
    const pattern = this.getPattern(countryName);
    return pattern ? pattern.test(postalCode.trim()) : true;
  }

  public format(postalCode: string, countryName: string): string {
    const cleaned = postalCode.replace(/\s+/g, "").toUpperCase();
    const country = countryName.toLowerCase();

    switch (country) {
      case "canada":
        return cleaned.length === 6
          ? `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`
          : cleaned;
      case "united kingdom":
        return cleaned.length >= 5
          ? `${cleaned.slice(0, -3)} ${cleaned.slice(-3)}`
          : cleaned;
      case "netherlands":
        return cleaned.length === 6
          ? `${cleaned.slice(0, 4)} ${cleaned.slice(4)}`
          : cleaned;
      case "united states":
        return cleaned.length === 9
          ? `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`
          : cleaned;
      case "japan":
        return cleaned.length === 7
          ? `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`
          : cleaned;
      case "brazil":
        return cleaned.length === 8
          ? `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`
          : cleaned;
      default:
        return cleaned;
    }
  }

  public getPlaceholder(countryName: string): string {
    return (
      postalCodePlaceholders[countryName.toLowerCase()] || "Enter postal code"
    );
  }
}

export default PostalCodeService;
